import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MeAccessResponse } from './me-access.model';

const AUTH_API_URL = `${environment.apiUrl.replace(/\/$/, '')}/uaa`;

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAccessApiService {
  private readonly http = inject(HttpClient);

  getMeAccess(): Observable<MeAccessResponse | null> {
    return this.http
      .get<MeAccessResponse>(`${AUTH_API_URL}/me/access`)
      .pipe(catchError(() => of(null)));
  }
}
